export default __webpack_public_path__ + "static/media/home.b30f0402.png";